export default () => {
  const buttons = document.querySelectorAll('[component="button"]');

  buttons.forEach((button) => {
    const linkChild = button.querySelector('[child="link"]');

    if (linkChild) {
      const { borderColor, backgroundColor, textCaps, borderRadius, borderWidth, textColor } =
        linkChild.dataset;

      if (borderColor) {
        linkChild.style.borderColor = borderColor;
      }

      if (backgroundColor) {
        linkChild.style.backgroundColor = backgroundColor;
      }

      if (borderRadius) {
        linkChild.style.borderRadius = borderRadius;
      }

      if (borderWidth) {
        linkChild.style.borderWidth = borderWidth;
      }

      if (textColor) {
        linkChild.style.color = textColor;
      }

      if (textCaps === 'true') {
        linkChild.style.textTransform = 'uppercase';
      }

      if (textCaps === 'false') {
        linkChild.style.textTransform = 'none';
      }
    }
  });
};
